import { useLocation } from 'react-router-dom'
import { ui } from '@/data/nav.en'
import { getLang } from '@/lib/lang'
// Yuichi 2026-09-16「実際にアップロードする際はオンラインショップの商品一覧と商品ページは、只今準備中という表示にして商品の表示はしないように制御」: 本番は既定で準備中。プレビュー環境だけ VITE_QB_SHOP_LIVE=1 で商品を表示
export const shopLive = import.meta.env.VITE_QB_SHOP_LIVE === '1'
export function ShopPreparing() {
  // EN ページ(/en/)では英語文言(構造・CSS は共通)。言語は pathname から判定(SSG のため window 参照禁止)
  const { pathname } = useLocation()
  const t = ui[getLang(pathname)]
  return <div className='shop-preparing'><div className='shop-preparing-orn' aria-hidden='true'><span /><i /><span /></div><p className='shop-preparing-en'>{t.shopPreparingEn}</p><h3>{t.shopPreparingH}</h3><p>{t.shopPreparingP}</p><a className='link-more' href={t.shopContact}>{t.shopPreparingLink}</a></div>
}
